module.exports = __webpack_public_path__ + "static/India-bg-dce78d36d074a4e69ebbc4089abb3e42.png";